import { DateRangePeriod } from "views/Account/Runs/Wrapper/constants";

export const NEW_TAB_IN_DRAWER_ID = "new-dashboard-view-in-drawer";
export const NEW_TAB_IN_LIST_ID = "new-dashboard-view";

export const VIEWS_LIMIT = 8;

export enum DefaultDashboardTabs {
  Overview = "overview",
  Metrics = "metrics",
  DORA = "dora",
}

export const DEFAULT_TAB_IDS = [
  DefaultDashboardTabs.Overview,
  DefaultDashboardTabs.Metrics,
  DefaultDashboardTabs.DORA,
] as string[];

export const DEFAULT_TAB_TITLES = {
  [DefaultDashboardTabs.Overview]: "Overview",
  [DefaultDashboardTabs.Metrics]: "Metrics",
  [DefaultDashboardTabs.DORA]: "DORA",
};

export const TAB_QUERY_STRING = "tab";

export const DASHBOARD_STORAGE_KEY = "dashboard";

export const DASHBOARD_HEADER_PENDO_FEEDBACK_ID = "pendo-feedback-id-for-dashboard-header";

export const RUNS_REQUIRING_ATTENTION_DATE_RANGE_PERIOD: DateRangePeriod = "last7Days";

export const RUN_TERMINATION_THRESHOLD_DAYS = 30;
export const RUN_TERMINATION_WARNING_WINDOW_DAYS = 7;
